// extracted by mini-css-extract-plugin
var _1 = "DocFlowMappingRecipientModalSuggestionsItem-moduleDocFlowMappingRecipientModalSuggestionsItem__XX5WG";
var _2 = "DocFlowMappingRecipientModalSuggestionsItem-moduleinfo__z5c0y";
var _3 = "DocFlowMappingRecipientModalSuggestionsItem-modulename__W0lRA";
export { _1 as "DocFlowMappingRecipientModalSuggestionsItem", _2 as "info", _3 as "name" }
